import {BrandKitExtractionSource} from '@Components/mystuff-brands/brand-kits.types';

/** What the thumbs say about the assets a route pulled in. */
export enum BrandKitExtractionFeedbackVerdict {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}

/** The toast's first line names where the assets came from. */
export const BRAND_KIT_EXTRACTION_FEEDBACK_TEXT_KEYS: Record<BrandKitExtractionSource, string> = {
  [BrandKitExtractionSource.DESIGN]: 'pmwjs_brand_kit_extraction_feedback_design',
  [BrandKitExtractionSource.LOGO]: 'pmwjs_brand_kit_extraction_feedback_logo',
  [BrandKitExtractionSource.WEBSITE]: 'pmwjs_brand_kit_extraction_feedback_website',
};

/** The phone toast's first line, which leaves out the source the desktop line names. */
export const BRAND_KIT_EXTRACTION_FEEDBACK_MOBILE_TEXT_KEY = 'pmwjs_brand_kit_extraction_feedback_mobile';

/** Why a thumbs-down was given, picked in the tablet and mobile follow-up sheet. Sent to GA4 as is. */
export enum BrandKitExtractionFeedbackReason {
  COLORS_MISMATCH = 'colors_mismatch',
  MISSING_ASSETS = 'missing_assets',
  OTHER = 'other',
}

/** A tablet or mobile thumbs-down once its reason is picked, with the optional free-text note. */
export interface BrandKitExtractionNegativeFeedback {
  source: BrandKitExtractionSource;
  reason: BrandKitExtractionFeedbackReason;
  note: string;
}

/** The steps a thumbs-down opens, one at a time: sheets on tablet and mobile, popovers over the toast on desktop. */
export enum BrandKitExtractionFollowUpStep {
  REASON = 'reason',
  ALTERNATIVES = 'alternatives',
  WEBSITE_URL = 'website-url',
  /** Not a thumbs-down step: the toast thanks the user for either verdict, then goes on its own. */
  THANKS = 'thanks',
}

/** Where a follow-up step draws: tablet's and mobile's sheets, or desktop's popovers over the toast. */
export enum BrandKitExtractionFeedbackLayout {
  SHEET = 'sheet',
  POPOVER = 'popover',
}

/** How long "Thanks for your feedback!" stays up before the toast goes. */
export const BRAND_KIT_EXTRACTION_THANKS_DURATION_MS = 4000;

/** How long a thumbs-up stays on screen, filled and popped as the handoff's click state draws it, before the toast thanks the user. */
export const BRAND_KIT_EXTRACTION_THUMBS_UP_SETTLE_MS = 700;

/** The open follow-up sheet, with the route it is about: the store's source is cleared once the verdict is recorded. */
export interface BrandKitExtractionFollowUp {
  step: BrandKitExtractionFollowUpStep;
  source: BrandKitExtractionSource;
}

/** The GA4 source of a kit started from the "Want to try something else instead?" sheet. */
export const BRAND_KIT_EXTRACTION_FOLLOW_UP_CREATION_SOURCE = 'ExtractionFeedback';
